/**
 * GSAP 플러그인 등록 — 앱 진입점에서 한 번만 import
 *
 * 사용 예시 (apps/admin/src/main.tsx 또는 layout):
 *   import '@lashpic/ui/motion/gsap-setup';
 *
 * (export alias는 frontend가 package.json exports에 통합할 예정)
 */
import { gsap } from 'gsap';
import { Flip } from 'gsap/Flip';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { CustomEase } from 'gsap/CustomEase';
import { useGSAP } from '@gsap/react';

/**
 * 무료 티어 플러그인을 등록.
 * DrawSVGPlugin은 Club GSAP(유료) 플러그인이므로 별도 라이선스 필요 시 앱 레이어에서 직접 등록.
 */
gsap.registerPlugin(Flip, ScrollTrigger, CustomEase, useGSAP);

/** 등록된 gsap 인스턴스를 재-export (직접 import하는 편의) */
export { gsap };
export { useGSAP };
